import React, { FC } from 'react';
import Error from 'components/AtomicStructure/atoms/Error';
import BuySellToggle from 'ui-library/components/BuySellToggle/BuySellToggle';
import {
    Modal, NumberInput, Title, RadioButtonGroup,
} from 'ui-library';
import { DEFAULT_APP_CURRENCY } from 'constants/constants';
import { ChangeInvestmentModalProps } from './ChangeInvestmentModalProps.types';

const ChangeInvestmentModal: FC<ChangeInvestmentModalProps> = (props) => {
    const {
        width,
        visible,
        closable,
        hasBorderRadius,
        okButtonProps,
        closeIcon,
        toggleChecked,
        toggleError,
        toggleDisabled,
        portfolioAmount,
        amount,
        amountIsValid,
        isCaseSource,
        isAzpOrAzpOld,
        azpRadioGroupOptions,
        resources,
        // Event handlers
        onOk,
        onCancel,
        onToggleChange,
        onAmountChanged,
        onAzpRadioChange,
    } = props;

    return (
        <Modal
            className={resources.modalClass}
            keyboard={false}
            maskClosable={false}
            width={width}
            visible={visible}
            okText={resources.okText}
            cancelText={resources.cancelText}
            closable={closable}
            borderRadius={hasBorderRadius}
            okButtonProps={okButtonProps}
            closeIcon={closeIcon}
            onOk={onOk}
            onCancel={onCancel}
        >
            <Title type={2} className="mb-24">
                {resources.title}
            </Title>
            <div className="edit-strategy-modal--current-strategy-info mb-24">
                {resources.portfolioAmountLabel}
                {' '}
                {portfolioAmount}
            </div>
            <div className="edit-investment mb-20">
                <BuySellToggle
                    offText={resources.toggleUncheckedLabel}
                    onText={resources.toggleCheckedLabel}
                    error={toggleError}
                    onChange={onToggleChange}
                    value={toggleChecked}
                    disabled={toggleDisabled}
                />
                <NumberInput
                    validation={{ minValue: 0 }}
                    id="investment"
                    placeholder=""
                    thousandSeparator="’"
                    decimalSeparator="."
                    label=""
                    prefix={`${DEFAULT_APP_CURRENCY} `}
                    value={amount}
                    required
                    error={amountIsValid}
                    onChange={onAmountChanged}
                    allowNegativeValue={false}
                    textRight
                />
            </div>
            {amountIsValid
                && (
                    <Error>
                        <span>{resources.amountErrorLabel}</span>
                    </Error>
                )}

            {isAzpOrAzpOld && toggleChecked
                && (
                    <div className="mt-3">
                        <div>
                            {resources.paragraph1}
                        </div>
                        <div>
                            {resources.paragraph3}
                        </div>
                        <div className="mt-20 azp-sell-radio-button-group">
                            <RadioButtonGroup
                                value={String(isCaseSource)}
                                options={azpRadioGroupOptions || []}
                                onChange={onAzpRadioChange}
                            />
                        </div>
                    </div>
                )}
        </Modal>
    );
};

export default ChangeInvestmentModal;
